import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/StockItemFileCabinetDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class StockItemFileCabinetEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/stockItemFileCabinet/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class StockItemFileCabinetFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public stockItemId: IFieldOptions = { field: "stockItemId" };
	public fileCabinetId: IFieldOptions = { field: "fileCabinetId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.stockItemId);
		this.push(this.fileCabinetId);
	}
}

export class StockItemFileCabinetForm implements IFormOptions {
	protected stockItemFileCabinetFormName: string = "stockItemFileCabinetForm";
	protected stockItemFileCabinetFormModel: models.StockItemFileCabinetDTO = new models.StockItemFileCabinetDTO();
	protected stockItemFileCabinetFormEndPoints: StockItemFileCabinetEndPoints = new StockItemFileCabinetEndPoints();
	protected stockItemFileCabinetFormFields: StockItemFileCabinetFormFields = new StockItemFileCabinetFormFields();
	public get name(): string { return this.stockItemFileCabinetFormName };
	public get model(): models.StockItemFileCabinetDTO { return this.stockItemFileCabinetFormModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemFileCabinetFormEndPoints };
       public set endPoints(stockItemFileCabinetEndPoints: IEntityEndPoints) {
		this.stockItemFileCabinetFormEndPoints = stockItemFileCabinetEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): StockItemFileCabinetFormFields { return this.stockItemFileCabinetFormFields };
}

export class StockItemFileCabinetListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public stockItemId: IColumnOptions = { field: "stockItemId" };
	public fileCabinetId: IColumnOptions = { field: "fileCabinetId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.stockItemId);
		this.push(this.fileCabinetId);
	}
}

export class StockItemFileCabinetList implements IGridOptions {
	protected stockItemFileCabinetListName: string = "stockItemFileCabinetList";
	protected stockItemFileCabinetListModel: models.StockItemFileCabinetDTO = new models.StockItemFileCabinetDTO();
	protected stockItemFileCabinetListEndPoints: StockItemFileCabinetEndPoints = new StockItemFileCabinetEndPoints();
	protected stockItemFileCabinetListColumns: StockItemFileCabinetListColumns = new StockItemFileCabinetListColumns();
	public stockItemFileCabinetForm: StockItemFileCabinetForm = new StockItemFileCabinetForm();
	public get name(): string { return this.stockItemFileCabinetListName };
	public get model(): models.StockItemFileCabinetDTO { return this.stockItemFileCabinetListModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemFileCabinetListEndPoints };
	public set endPoints(stockItemFileCabinetEndPoints: IEntityEndPoints) {
		this.stockItemFileCabinetListEndPoints = stockItemFileCabinetEndPoints;
		this.stockItemFileCabinetForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): StockItemFileCabinetListColumns { return this.stockItemFileCabinetListColumns };
}

export class StockItemFileCabinetEntity implements IEntityOptions {
	protected stockItemFileCabinetEntityName: string = "stockItemFileCabinetEntity";
	protected stockItemFileCabinetEntityModel: models.StockItemFileCabinetDTO = new models.StockItemFileCabinetDTO();
	protected stockItemFileCabinetEntityEndPoints: StockItemFileCabinetEndPoints = new StockItemFileCabinetEndPoints();
	protected stockItemFileCabinetEntityList: StockItemFileCabinetList = new StockItemFileCabinetList();
	public get name(): string { return this.stockItemFileCabinetEntityName };
	public get model(): models.StockItemFileCabinetDTO { return this.stockItemFileCabinetEntityModel };
	public get endPoints(): IEntityEndPoints { return this.stockItemFileCabinetEntityEndPoints };
	public set endPoints(stockItemFileCabinetEndPoints: IEntityEndPoints) {
		this.stockItemFileCabinetEntityEndPoints = stockItemFileCabinetEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): StockItemFileCabinetList { return this.stockItemFileCabinetEntityList };
	public get form(): StockItemFileCabinetForm { return this.grid.stockItemFileCabinetForm };
	constructor(name?: string) {
		if (name) this.stockItemFileCabinetEntityName = name;
		this.endPoints = this.stockItemFileCabinetEntityEndPoints;
	}
};
//export class StockItemFileCabinetGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: StockItemFileCabinetForm = new StockItemFileCabinetForm();
//};

//export class StockItemFileCabinetListPageComponent extends ListPageComponent {
  //protected listPageComponentList: StockItemFileCabinetList = new  StockItemFileCabinetList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class StockItemFileCabinetBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: StockItemFileCabinetGeneratedForm}];
//};

//export class StockItemFileCabinetListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: StockItemFileCabinetListPageComponent, isMenuHidden: true }];
//};

